import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useStore, KEYS, sortPosts, formatDate } from "../admin/store";
import AuthorAvatar from "./AuthorAvatar";

const BlogPosts = () => {
    const [search, setSearch] = useState("");
    const posts = useStore(KEYS.posts);
    const authors = useStore(KEYS.authors);

    const published = useMemo(
        () => sortPosts(posts.filter((p) => p.status === "published")),
        [posts]
    );

    const q = search.toLowerCase();
    const filteredPosts = published.filter(
        (post) =>
            post.title.toLowerCase().includes(q) ||
            (post.excerpt || "").toLowerCase().includes(q) ||
            (post.category || "").toLowerCase().includes(q)
    );

    return (
        <section>
            {/* ✅ Search Bar */}
            <div className="flex justify-center mb-10 relative">
                <div className="relative w-full md:w-1/2">
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search blog articles or services..."
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600 pr-10"
                    />
                    {search && (
                        <button
                            type="button"
                            onClick={() => setSearch("")}
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                            ✕
                        </button>
                    )}
                </div>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredPosts.map((post) => {
                    const author = authors.find((a) => a.id === post.authorId);
                    return (
                        <Link
                            key={post.id}
                            to={`/blog/${post.slug}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex flex-col bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 overflow-hidden"
                        >
                            <img
                                src={post.image || "/assets/Blog/1.jpg"}
                                alt={post.title}
                                className="w-full h-48 object-cover"
                                loading="lazy"
                            />
                            <div className="p-5 flex flex-col flex-1">
                                {post.category && (
                                    <span className="text-xs font-semibold uppercase tracking-wide text-blue-600 mb-2">
                                        {post.category}
                                    </span>
                                )}
                                <h2 className="text-xl font-semibold text-blue-900 mb-2">{post.title}</h2>
                                <p className="text-gray-600 text-sm mb-4">{post.excerpt}</p>
                                <div className="mt-auto flex items-center gap-3 pt-3 border-t border-gray-100">
                                    <AuthorAvatar author={author} size={36} />
                                    <div className="min-w-0">
                                        <p className="text-sm font-medium text-gray-800 truncate">
                                            {author ? author.name : "MM AutoTech Team"}
                                        </p>
                                        <p className="text-xs text-gray-400">
                                            {formatDate(post.date)}
                                            {post.readTime ? ` · ${post.readTime}` : ""}
                                        </p>
                                    </div>
                                </div>
                                <span className="text-blue-600 font-medium hover:underline mt-4">Read More →</span>
                            </div>
                        </Link>
                    );
                })}

                {/* ✅ No Results */}
                {filteredPosts.length === 0 && (
                    <p className="text-center text-gray-500 col-span-full">
                        No matching services or articles found.
                    </p>
                )}
            </div>
        </section>
    );
};

export default BlogPosts;
